import { lazy } from 'react';

export const PopeLandAsync = lazy(() => import('./pope.land'));
